import { useTranslation } from "react-i18next";
import { Button } from "../button/Button";
import { useNavigate } from "react-router-dom";
import { HOME } from "../../lib/routesResolver";

const InfoPageContainer = ({ type }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-row gap-x-4 mt-[5%] mb-[5%] items-center">
      <div className="w-1/2 flex flex-col">
        <div className="text-6xl text-primary font-bold text-center">
          {t(type?.title)}
        </div>
        <div className="text-xl font-semibold text-center">{t(type?.text)}</div>
        <div className="text-center mt-6">
          <Button className="w-fit text-center" onClick={() => navigate(HOME)}>
            {t("infoPages.homeButton")}
          </Button>
        </div>
      </div>
      <div className="w-1/2 flex justify-center">
        <img className="h-[400px]" src={type?.image} alt={t(type?.alt)} />
      </div>
    </div>
  );
};

export default InfoPageContainer;
